import { nanoid } from 'nanoid';

import { FOLDER_ID_CUSTOM, QUESTION_TYPES } from '@api/instant_survey';

/**
 * Strips ids for questions and answers when editing a recommended question or duplicating an existing question
 * @param {Object} options
 * @param {Object[]} options.availableQuestionTypes
 * @param {Boolean} [options.isDuplicate]
 * @param {Object} options.question
 */
export const prepExistingQuestion = ({ availableQuestionTypes, isDuplicate, question }) => {
  const isCreating = isDuplicate || question.folder !== FOLDER_ID_CUSTOM;
  const answers = question.answers.map((answer) => ({
    ...answer,
    id: isCreating ? nanoid() : answer.id,
  }));
  const subQuestions = question.subQuestions.map((subQuestion) => ({
    ...subQuestion,
    id: isCreating ? nanoid() : subQuestion.id,
  }));

  return {
    ...question,
    answers: answers.filter(({ isNoneOfTheAbove }) => !isNoneOfTheAbove),
    id: isCreating ? undefined : question.id,
    noneAnswer: answers.find(({ isNoneOfTheAbove }) => isNoneOfTheAbove) || null,
    properties: {
      ...question.properties,
    },
    subQuestions,
    type:
      availableQuestionTypes.find(({ value }) => value === question.type)?.value ||
      QUESTION_TYPES.ESSAY.value,
  };
};
